import {TaxYearInput} from '../schema-types/globalTypes';

export const getTaxyear = (todaysDate: Date): TaxYearInput => {
  // javascript returns the months with the index starting at zero
  const currentMonth = todaysDate.getUTCMonth() + 1;
  const currentDayOfTheMonth = todaysDate.getUTCDate();
  const currentCalendarYear = todaysDate.getUTCFullYear();

  if (currentMonth > 4 || (currentMonth === 4 && currentDayOfTheMonth >= 6)) {
    // Current tax year starts this April
    return {
      endYear: currentCalendarYear + 1,
      startYear: currentCalendarYear,
    };
  }
  // Current tax year is the one starting in the previous year
  return {
    endYear: currentCalendarYear,
    startYear: currentCalendarYear - 1,
  };
};

export const getTaxYearDropdownOptions = (todaysDate: Date): TaxYearInput[] => {
  const currentTaxYear = getTaxyear(todaysDate);
  const previousTaxYear: TaxYearInput = {
    endYear: Number(currentTaxYear.endYear) - 1,
    startYear: Number(currentTaxYear.startYear) - 1,
  };
  return [currentTaxYear, previousTaxYear];
};

export const getTaxYearFromEndYear = (taxYears: TaxYearInput[], endYear: number) =>
  taxYears.find((taxYear) => taxYear.endYear === endYear);

export const getTaxYear4Digits2Digits = (taxYear?: unknown): string | undefined => {
  if (typeof taxYear === 'string' && (taxYear.match(/\d{4}\/\d{2}/g) ?? []).length > 0) {
    return taxYear;
  }
  return undefined;
};
